import { WorkAvailableArea } from '../model/vo/agent';

/**
 * 시도 그룹핑 구조를 "시도 시구" 평면 문자열 배열로 변환한다.
 * (기존 평면 렌더 소비처의 하위호환 유지용)
 * 시구가 없는 시도(예: 세종)는 시도명만 반환한다.
 */
export const flattenWorkAvailableAreas = (
  areas?: WorkAvailableArea[],
): string[] =>
  (areas ?? []).flatMap((area) =>
    area.sigu.length
      ? area.sigu.map((sigu) => `${area.sido} ${sigu}`)
      : [area.sido],
  );

/**
 * 전체 상담가능 지역(군구) 총 개수.
 * 시구가 없는 시도(세종 등)는 시 단위로 1개 계수한다.
 */
export const getTotalAreaCount = (areas?: WorkAvailableArea[]): number =>
  (areas ?? []).reduce((count, area) => count + (area.sigu.length || 1), 0);

/**
 * 대표 상담가능 지역 텍스트 (API 순서상 top1: 첫 시도 + 첫 시구).
 * 시구가 없으면 시도명만 반환한다.
 */
export const getRepresentativeAreaText = (
  areas?: WorkAvailableArea[],
): string => {
  const first = areas?.[0];
  if (!first) return '';
  return first.sigu.length ? `${first.sido} ${first.sigu[0]}` : first.sido;
};

/**
 * 대표 지역을 제외한 나머지 지역 수 ("외 N개 지역"의 N).
 */
export const getExtraAreaCount = (areas?: WorkAvailableArea[]): number =>
  Math.max(0, getTotalAreaCount(areas) - 1);
